module.exports = __webpack_public_path__ + "static/ICONFOOTER-10-960f2da8f240ca9b67babc9bfba5b4aa.png";